import { NativeModulesProxy } from 'expo-modules-core';

import ExpoCompressView, { ExpoCompressViewProps } from './ExpoCompressView'

const { ExpoCompress } = NativeModulesProxy;

export async function helloAsync(options: Record<string, string>) {
  return await ExpoCompress.helloAsync(options);
}

export {
  ExpoCompressView,
  ExpoCompressViewProps
};
